import Reviews from 'containers/reviews'

export default Reviews
